import { Link } from "react-router-dom";

export default function NoneConfigData() {
  return (
    <div>
      <div className="conf_main" style={{ padding: 24 }}>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: 8,
            padding: 24,
            background: "#fafafa",
            textAlign: "center",
          }}
        >
          <p style={{ fontSize: 16, marginBottom: 8, fontWeight: 600 }}>
            그룹(병동) 정보가 없습니다.
          </p>
          <p style={{ fontSize: 14, marginBottom: 16 }}>
            근무자 관리 페이지에서 그룹과 근무자를 먼저 등록해 주세요.
          </p>
          <Link to="/head_nurse_management" className="comp_btn">
            근무자 관리 페이지로 이동
          </Link>
        </div>
      </div>
    </div>
  );
}
